import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Materia Prima",
    items: [
      { label: "Materia Prima",             icon: "fas fa-fill",        href: "/ListadoTelas",            key: "catalogos.materiaPrima.ver"       },
      { label: "Colores",                   icon: "fas fa-palette",     href: "/Colores",                 key: "catalogos.colores.ver"       },
      // { label: "Salidas Materia Prima",     icon: "fas fa-dolly-flatbed", href: "/ListadoSalidaTelas",    perm: "menu_telas"       },
    ],
  },
  {
    title: "Producción (plásticos)",
    items: [
      { label: "Máquinas",         icon: "fas fa-industry",  href: "/Maquinas",        key: "catalogos.maquinas.ver" },
      { label: "Moldes Inyección", icon: "fas fa-fill-drip", href: "/MoldesInyeccion", key: "catalogos.moldes.ver" },
      { label: "Moldes Soplado", icon: "fas fa-wine-bottle", href: "/MoldesSoplado", key: "catalogos.moldesSoplado.ver" },
      { label: "Turnos",           icon: "fas fa-clock",     href: "/Turnos",          key: "catalogos.turnos.ver" },
      // { label: "Config Plásticos", icon: "fas fa-sliders-h", href: "/ConfigPlasticos", perm: "menu_articulos" },
    ],
  },
  {
    title: "Artículos (botellas)",
    inline: true,
    items: [
      { label: "Artículos",   icon: "fas fa-wine-bottle", href: "/ListadoArticulos", key: "catalogos.articulos.ver" },
    ],
  },
  {
    title: "Clientes",
    inline: true,
    items: [
      { label: "Clientes",    icon: "fas fa-user-tie", href: "/Clientes",           key: "catalogos.clientes.ver" },
    ],
  },
  {
    title: "Proveedores",
    inline: true,
    items: [
      { label: "Proveedores", icon: "fas fa-dolly", href: "/Proveedores", key: "catalogos.proveedores.ver" },
    ],
  },
];

function BotonesMateriales() {
  return (
    <MenuGrid
      title="Catálogos"
      subtitle="Materia prima, artículos, máquinas, moldes, turnos, clientes y proveedores"
      icon="fas fa-box"
      accent={{ color: "#10b981", bg: "#f0fdf4" }}
      modulo="catalogos"
      sections={SECTIONS}
    />
  );
}

export default BotonesMateriales;
